import { EAnimalTypesUI } from 'data/types/animal.types';

export const modalTitle: { [key: string]: string } = {
  [EAnimalTypesUI.PET]: 'Pet',
  [EAnimalTypesUI.ESA]: 'Emotional Support Animal (ESA)',
  [EAnimalTypesUI.SA]: 'Service Animal (SA)',
};
